export const POST_PARTICIPATION_SUBHEADINGS = {
    'Custom Form': 'Gather extra details from participants.',
    'Standard Form': 'Collects basic information about participants. ',
  } as const;